<template>
    <div>
        <agile
            :nav-buttons="false"
            :infinite="images.length > 1"
            :dots="images.length > 1"
        >
            <div v-for="image in images" :key="image._id" v-viewer>
                <img :src="image.url" class="slide" alt="" />
            </div>
        </agile>
    </div>
</template>

<script>
import { VueAgile } from 'vue-agile';
export default {
    components: {
        agile: VueAgile,
    },
    props: {
        images: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    computed: {
        imagesURL() {
            return this.images.map((image) => image.url);
        },
    },
};
</script>

<style scoped>
.slide {
    display: block;
    max-height: 250px;
    width: 100%;
}
img {
    object-fit: cover;
}
</style>
<style lang="sass" scoped>
@import "~viewerjs/dist/viewer.css"
// Basic VueAgile styles
::v-deep .agile
  width: 100%

  &__actions
    margin-top: 20px

  &__nav-button
    background: transparent
    border: none
    color: #fff
    cursor: pointer
    font-size: 24px
    height: 100%
    position: absolute
    top: 0
    transition-duration: .3s
    width: 80px

    &:hover
      color: #888
      background-color: rgba(#000, .5)
      opacity: 1
    &--prev
      left: 0

    &--next
      right: 0
  &__dots
    bottom: 2rem
    left: 50%
    position: absolute
    transform: translateX(-50%)
    list-style: none

  &__dot
    margin: 0 10px

    button
      background-color: #eee
      border: none
      border-radius: 50%
      cursor: pointer
      display: block
      height: 10px
      font-size: 0
      line-height: 0
      margin: 0
      padding: 0
      transition-duration: .3s
      width: 10px

    &--current,
    &:hover
      button
        background-color: #888
</style>
